module.exports = __webpack_public_path__ + "img/Access-to-Safe-Drinking-Water-650x340.56d50422.png";